import { stringEnum } from '@/models/type-generators/string-enum';

export type MatrixProcess = 'CONTROL' | 'INTEGRATION';
export const MatrixProcess = stringEnum<MatrixProcess>();
